import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

/**
 * <ErrorMessageDialog message onClose = {} />
 */

class ErrorMessageDialog extends Component {

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Ошибка
			</DialogTitle>

			<DialogContent>
				{this.props.message}
			</DialogContent>

			<DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onClose === "function") {
							this.props.onClose()
						}
					}}
				>Ок</Button>

			</DialogActions>

		</Dialog>

	}

}

export default ErrorMessageDialog
